import { render, staticRenderFns } from "./vendasdaequipe.vue?vue&type=template&id=4a652500"
import script from "./vendasdaequipe.vue?vue&type=script&lang=js"
export * from "./vendasdaequipe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports